import { api } from "../AxiosInstance";
import {api as tenantApi} from "../../../../src/Connections/AxiosInstance"

export function getOrgApi(params) {
  return api().get("api/Organization/GetAll", { params });
}

export function getTenantsApi(params) {
  return api().get("api/Tenant/GetAllTenantByOrganization", { params });
}

export function addOrgApi(data) {
  return api().post("api/Organization/Register", data);
}

export function editOrgApi(data) {
  return api().put("/api/Organization/Update", data);
}

export function addTenantApi(data) {
  return api().post("/api/Tenant/CreateByCurrentOrganization", data);
}

export function comparePolygonsApi(params) {
  return api().get("/api/Organization/PlansCurrentAndInitialPolys", { params });
}

export function editTenantApi(data) {
  return api().put("/api/Tenant/Update", data);
}

export function getOrgByIdApi(params) {
  return api().get("api/Organization/GetOrganizationById", { params });
}

export function changeOrgActivationApi(data) {
  return api().put("api/Organization/DeactivateOrganizationById", data);
}

export function changeTenantActivationApi(data) {
  return api().put("/api/Tenant/DeactivateTenantById", data);
}

export function getTenantByIdApi(params) {
  return api().get("/api/Tenant/GetById", { params });
}

export function deleteTenantApi(data) {
  return api().delete("/api/Tenant/DeleteById", data);
}

export function getOrganizationUserApi(params) {
  return api().get("/api/User/GetOrganizationUser", { params });
}

export function getTenantUserApi(params) {
  return api().get("/api/User/GetTenantUser", { params });
}

export function updateOrgUserApi(data) {
  return api().put("/api/User/UpdateOrganizationUser", data);
}

export function updateTenantUserApi(data) {
  return api().put("/api/User/UpdateTenantUser", data);
}

export function changeTenantPasswordApi(data) {
  return api().put("/api/User/ChangePasswordOfTenant", data);
}

export function getUserTokenApi(params) {
  return api().get("/api/Auth/GetTokenForUser", { params });
}

export function getUserTokenByTenantIdApi(params) {
  return api().get("/api/Auth/GetTokenForTenant", { params });
}

export function getTokenForOrganizationApi(params) {
  return api().get("/api/Auth/GetTokenForOrganization", { params });
}

export function getOrganizationUsageApi(params) {
  return api().get("/api/Account/GetOneOrganizationUsage", { params });
}

export function downloadUsageApi(params) {
  return api().get("/api/Account/DownloadUsage", { params });
}

export function getOrgPOCApi(params) {
  return api().get("/api/Organization/GetOrganizationPOCType", { params });
}

export function updateOrgPOCApi(data) {
  return api().put("/api/Organization/UpdateOrganizationPOCType", data);
}

export function addOrgPOCApi(data) {
  return api().put("/api/Organization/SetOrganizationPOCType", data);
}

export function removeOrgPOCApi(params) {
  return api().delete("/api/Organization/DeleteOrganizationPOCType", { params });
}

export function deliveryReportApi(params) {
  return api().get("/api/organization/DownloaDeliveryReportOfOrganization", { params });
}

export function deliveryCoordinatesReportApi(params) {
  return tenantApi().get("/api/organization/DownloadDeliveryCoordinatesReport", { params });
}